import { FC } from "react"
import { useTranslation } from "react-i18next"
import { StarIcon, Ton3dIcon } from "@/assets"
import { useGetMyInfluencerQuery } from "@/store/apis/referralAPI"
import styles from "./RewardsPanel.module.scss"

export const RewardsPanel: FC = () => {
  const { t } = useTranslation()
  const { data, isLoading, isError } = useGetMyInfluencerQuery()

  const renderPercent = (value: number | undefined) => {
    if (isLoading) {
      return <span className={styles.RewardsPanel_skeleton} />
    }
    if (isError || value === undefined) {
      return t("referrals.details.rewards.percentFallback")
    }
    return t("referrals.details.rewards.percent", { percent: value })
  }

  return (
    <div className={styles.RewardsPanel}>
      <div className={styles.RewardsPanel_operationType}>
        <div className={styles.RewardsPanel_operationDescription}>
          {t("referrals.details.rewards.operationDescription")}
        </div>
      </div>

      <div className={styles.RewardsPanel_friendRewards}>
        <div className={styles.RewardsPanel_friendRewardsTitle}>
          {t("referrals.details.rewards.friendRewardsTitle")}
        </div>
        <div className={styles.RewardsPanel_rewardsRow}>
          <div className={styles.RewardsPanel_rewardItem}>
            <StarIcon className={styles.RewardsPanel_rewardIcon} />
            <span className={styles.RewardsPanel_rewardValue}>
              {renderPercent(data?.starClaimPercentage)}
            </span>
          </div>
          <div className={styles.RewardsPanel_rewardAnd}>&</div>
          <div className={styles.RewardsPanel_rewardItem}>
            <Ton3dIcon className={styles.RewardsPanel_rewardIcon} />
            <span className={styles.RewardsPanel_rewardValue}>
              {renderPercent(data?.tonClaimPercentage)}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
